<template>
  <abk-skills-list skills-type="connectedWithCompetences"/>
</template>

<script>
import AbkSkillsList from '../../../components/skills/AbkSkillsList'

export default {
  name: 'SkillsConnectedWithCompetencesTab',
  components: { AbkSkillsList },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.skills.list_tabs.skills_connected_with_competences_tab.title'),
        subtitle: this.$t('views.skills.list_tabs.skills_connected_with_competences_tab.subtitle')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style scoped lang="scss">
</style>
